import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { getKnownLiftingOrder } from "selectors";
import { LiftingOrder, ReduxState } from "types";

export const useKnownLiftingOrder = (platformIdFromProps?: string) => {
  const { meetId, platformId } = useParams<{
    meetId: string;
    platformId: string;
  }>();

  const props = React.useMemo(() => {
    return {
      match: {
        params: { meetId, platformId: platformIdFromProps ?? platformId },
      },
    };
  }, [meetId, platformId, platformIdFromProps]);

  const knownLiftingOrder = useSelector((state: ReduxState) =>
    getKnownLiftingOrder(state, props)
  ) as LiftingOrder;

  return knownLiftingOrder;
};
